(function () {
  const controlScript = document.currentScript;
  const labels = [
    ['.ot-floating-button__open', controlScript?.dataset.openCookieLabel],
    ['.ot-floating-button__close', controlScript?.dataset.closeCookieLabel],
  ];
  let observer;
  let observerTimeout;

  function stopObserving() {
    observer?.disconnect();
    observer = null;
    clearTimeout(observerTimeout);
  }

  function labelFloatingButtons() {
    let complete = true;
    labels.forEach(([selector, label]) => {
      const button = document.querySelector(selector);
      if (!button) {
        complete = false;
      } else if (label && !button.getAttribute('aria-label')) {
        button.setAttribute('aria-label', label);
      }
    });
    if (complete) stopObserving();
    return complete;
  }

  function watchFloatingButtons() {
    if (labelFloatingButtons() || observer || !document.body) return;
    observer = new MutationObserver(labelFloatingButtons);
    observer.observe(document.body, { childList: true, subtree: true });
    observerTimeout = setTimeout(stopObserving, 10000);
  }

  document.addEventListener('click', (event) => {
    const link = event.target.closest?.('[data-cookie-settings]');
    if (!link || event.defaultPrevented || event.button !== 0
      || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    if (typeof window.OneTrust?.ToggleInfoDisplay !== 'function') return;

    try {
      window.OneTrust.ToggleInfoDisplay();
      event.preventDefault();
      watchFloatingButtons();
    } catch (error) {
      console.warn('Cookie settings are unavailable; opening the privacy policy.');
    }
  });

  window.addEventListener('OneTrustGroupsUpdated', watchFloatingButtons);
  watchFloatingButtons();
}());
